module.exports = __webpack_public_path__ + "static/media/14.86ecab2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shoes/14.png
// module id = 1511
// module chunks = 0